module.exports = __webpack_public_path__ + "static/16-93a3265147b0a785cc6ccd681e263489.jpg";